import React, { useState, useEffect, useImperativeHandle } from "react";
import { GameState } from "../types";

interface TimerProps {
  gameState: GameState;
  onClick: () => void;
}

const Timer = React.forwardRef(({ gameState, onClick }: TimerProps, ref) => {
  const [gameSeconds, setGameSeconds] = useState(0);

  useEffect(() => {
    let id: NodeJS.Timer | null = null;
    if (gameState === GameState.playing) {
      id = setInterval(() => {
        setGameSeconds((t) => t + 1);
      }, 1000);
    }
    return () => {
      id && clearInterval(id);
    };
  }, [gameState]);

  const getTime = () => {
    const minitues = Math.floor(gameSeconds / 60);
    const seconds = gameSeconds % 60;

    const shownSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    const shownMinitues = minitues < 10 ? `0${minitues}` : `${minitues}`;
    return `${shownMinitues}:${shownSeconds}`;
  };

  useImperativeHandle(ref, () => ({
    setGameSeconds,
  }), [])

  return (
    <span>
      时间：{getTime()} <button onClick={onClick}>p</button>
    </span>
  );
});

export default React.memo(Timer);
